import { Box } from '@mui/material';
import { FOOTER_LOGO_HEIGHT } from 'theme';
import praxioLogo from 'assets/images/logo_praxio.png';
import praxioLogoSquare from 'assets/images/praxio_logo_square.png';

function DrawerBottom({ collapsed = false }) {
  return (
    <Box
      sx={{
        height: FOOTER_LOGO_HEIGHT,
        flexShrink: 0,
        borderTop: '2px solid #FF3D03',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        alt='logo'
        src={praxioLogo}
        style={{
          width: '102px',
          height: 'auto',
          display: collapsed ? 'none' : 'block',
        }}
      />
      <img
        alt='logo'
        src={praxioLogoSquare}
        style={{
          height: '39px',
          width: 'auto',
          display: collapsed ? 'block' : 'none',
        }}
      />
    </Box>
  );
}
export default DrawerBottom;
